import styled from 'styled-components'
import {Label} from '@modifi/ui'

export const RequiredLabel = styled(Label)`
  &::after {
    content: '*';
    font-weight: 400;
  }
`
